export const SERVER_URL = import.meta.env.VITE_SERVER_URL || 'http://localhost:8000';
